const KEY = 'pendingOrgSignup';

export const getPendingOrgSignup = () => {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (_e) {
    return null;
  }
};

export const setPendingOrgSignup = (data) => {
  try {
    localStorage.setItem(KEY, JSON.stringify(data));
  } catch (_e) {
    // localStorage unavailable — fall through silently
  }
};

export const clearPendingOrgSignup = () => {
  try {
    localStorage.removeItem(KEY);
  } catch (_e) {
    // localStorage unavailable — fall through silently
  }
};
